import InterfacePenunjang from "@/apiInterface/InterfacePenunjang";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

class DataPenunjang {
  async getListLab() {
    let dt: any;
    await InterfacePenunjang.getGroupLayananLab()
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Order Laboratorium");
      });
    return dt;
  }

  async getListRadiologi() {
    let dt: any;
    await InterfacePenunjang.getGroupLayananRadiologi()
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Order Radiologi");
      });
    return dt;
  }
  async getDataOrderLabById(id) {
    // let dt: object = {}
    let dt: any;
    await InterfacePenunjang.getOrderLabById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        dt = e;
        ErrorAlert.showSnackAlert(e, "Order Laboratorium");
      });
    return dt;
  }
  async getDataOrderRadiologiById(id) {
    // let dt: object = {}
    let dt: any;
    await InterfacePenunjang.getOrderRadiologiById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        dt = e;
        ErrorAlert.showSnackAlert(e, "Order Radiologi");
      });
    return dt;
  }
  async saveDataOrderLab(
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items,
    prioritas
  ) {
    let dt: object = {};
    await InterfacePenunjang.saveOrderLab(
      register_id,
      date,
      unit_id,
      pasien_rm,
      clinical_note,
      other_note,
      dokter_id,
      items,
      prioritas
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async saveDataOrderRadiologi(
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items
  ) {
    let dt: object = {};
    await InterfacePenunjang.saveOrderRadiologi(
      register_id,
      date,
      unit_id,
      pasien_rm,
      clinical_note,
      other_note,
      dokter_id,
      items
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }
  async editDataOrderLab(
    id,
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items,
    prioritas
  ) {
    let dt: object = {};
    await InterfacePenunjang.editOrderLab(
      id,
      register_id,
      date,
      unit_id,
      pasien_rm,
      clinical_note,
      other_note,
      dokter_id,
      items,
      prioritas
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataOrderRadiologi(
    id,
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items
  ) {
    let dt: object = {};
    await InterfacePenunjang.editOrderRadiologi(
      id,
      register_id,
      date,
      unit_id,
      pasien_rm,
      clinical_note,
      other_note,
      dokter_id,
      items
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async getDataOrderLabByReg(reg) {
    let dt: any;
    await InterfacePenunjang.getOrderLabByReg(reg)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Order Laboratorium");
      });
    return dt;
  }

  async getDataOrderRadiologiByReg(reg) {
    let dt: any;
    await InterfacePenunjang.getOrderRadiologiByReg(reg)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Order Radiologi");
      });
    return dt;
  }

  async cancelDataOrderLab(id, alasan) {
    let dt: any;
    await InterfacePenunjang.cancelOrderLab(id, alasan)
      .then(response => {
        dt = response;
        // console.log(dt);
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async cancelDataOrderRadiologi(id, alasan) {
    let dt: any;
    await InterfacePenunjang.cancelOrderRadiologi(id, alasan)
      .then(response => {
        dt = response;
        // console.log(dt);
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async saveDataTemplate(nama, category, items) {
    let dt: object = {};
    await InterfacePenunjang.saveTemplate(nama, category, items)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }
  async getDataTemplate(type) {
    let dt: any;
    await InterfacePenunjang.getTemplate(type)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Template");
      });
    return dt;
  }
  async getDataListHasilRo(reg) {
    let dt: any;
    await InterfacePenunjang.getListHasilRo(reg)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Hasil Radiologi ");
      });
    return dt;
  }
  async getDataListHasilRoByRm(rm) {
    let dt: any;
    await InterfacePenunjang.getListHasilRoByRm(rm)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Hasil Radiologi ");
      });
    return dt;
  }
  async getDataDetailHasilRo(no_trans, tgl, kode) {
    let dt: any;
    await InterfacePenunjang.getDetailHasilRo(no_trans, tgl, kode)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Detail Hasil Radiologi");
      });
    return dt;
  }

  async getDataListHasilLab(reg) {
    let dt: any;
    await InterfacePenunjang.getListHasilLab(reg)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Hasil Laboratorium");
      });
    return dt;
  }
  async getDataListHasilLabByRm(rm, tgl_masuk, tgl_keluar) {
    let dt: any;
    await InterfacePenunjang.getListHasilLabByRm(rm, tgl_masuk, tgl_keluar)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Hasil Laboratorium By RM");
      });
    return dt;
  }

  async getDataRiwayatLab(rm, tgl_masuk = "", tgl_keluar = "") {
    let dt: any;
    await InterfacePenunjang.getRiwayatLab(rm, tgl_masuk, tgl_keluar)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Riwayat Hasil Laboratorium");
      });
    return dt;
  }

  async getDataKategoriPenunjangLain() {
    let dt: any;
    await InterfacePenunjang.getKategoriPenunjangLain()
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Kategori Penunjang Lain");
      });
    return dt;
  }

  async getDataKbMetode() {
    let dt: any;
    await InterfacePenunjang.getKbMetode()
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Jenis Tindakan KB");
      });
    return dt;
  }

  async getDataPenunjangLainByReg(reg) {
    let dt: any;
    await InterfacePenunjang.getPenunjangLain(reg)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Penunjang Lain");
      });
    return dt;
  }

  async getDataPenunjangLainByRm(rm) {
    let dt: any;
    await InterfacePenunjang.getPenunjangLainByRm(rm)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Penunjang Lain");
      });
    return dt;
  }
  async saveDataPenunjangLain(param) {
    // async saveDataPenunjangLain(penunjang_lain_kategori_id,register_id,tanggal,waktu_periksa,unit_id,pasien_rm,catatan,file) {
    console.log("param", param);
    let dt: object = {};
    await InterfacePenunjang.savePenunjangLain(param)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async deletePenunjangLainItem(id) {
    await http
      .deleteData(`/penunjang-lain/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        ErrorAlert.showErrorAlert(e);

        return e.response;
      });
  }
}

export default new DataPenunjang();
